import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Card, DataTable, Thumbnail } from '@shopify/polaris';
import PlaceholderImage from 'images/image-placeholder.png'

const propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
  })),
}

const defaultProps = {

}

const SoldItemStats = (props) => {

  const buildRows = useCallback( () => props.items.map((item) => {
    return [
      <Thumbnail source={ item.image_url || PlaceholderImage } alt={ item.title } />,
      item.title,
      `${item.quantity} unidades`,
    ]
  }), [props.items.length]);

  const rows = buildRows();


  return (
    <DataTable
      rows={rows}
      headings={[]}
      verticalAlign="middle"
      columnContentTypes={['text', 'text', 'numeric' ]}
    />
  )
};

const Test = ({ url }) => (
  <Link external url={url} removeUnderline>Ver</Link>
)

SoldItemStats.propTypes = propTypes;
SoldItemStats.defaultProps = defaultProps;

export default SoldItemStats;